import { createTableSlice } from '../helpers';
import { TaskStatus } from '../../constants';

export const tableSlice = createTableSlice({
  name: 'labellerDashboard/finishedTable',
  url: '/api/labelTasks',
  filters: {
    status: TaskStatus.FINISHED,
  },
});
